import {AxiosRequestConfig} from 'axios';
import {apiConfig} from 'libs/api/api';

export const fetcherMagento = <T>(config: AxiosRequestConfig): Promise<T> => {
    const promise = apiConfig.instanceGusaBackend(config).then((response) => {
        return response.data;
    });

    return promise;
};

export const fetcherMs = <T>(config: AxiosRequestConfig): Promise<T> => {
    const promise = apiConfig
        .instanceGusaBackend({...config, baseURL: apiConfig.API_URL})
        .then((response) => {
            return response.data;
        });

    return promise;
};
